import { Injectable, inject } from '@angular/core';
import { UserPositionTypesService } from '@control-tower/platform-core';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class UserPositionTypeFacade extends AbstractTypeEntityFacade<UserPositionTypesService> {
    constructor() {
        const userPositionTypeService = inject(UserPositionTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            userPositionTypeService,
            'userPositionTypeGetAll',
            TypeEntityTypes.UserPositionType
        );
    }
}
